import { GroupTemplate as BackendGroupTemplate } from "@longtail-education/superprep-data-model-frontend"

/**
 * Represents a group template, extending the backend group template model.
 */
export class GroupTemplate extends BackendGroupTemplate {
  /** The unique identifier of the group template. */
  declare id: string

  static compare<T extends { id?: string }>(a: T, b: T, ids: string[], asc = true): number {
    return (a.id && b.id && ids.indexOf(a.id) > ids.indexOf(b.id) ? 1 : -1) * (asc ? 1 : -1)
  }
}
